export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  SERVICES: '/services',
  ENQUIRY: '/enquiry',
  HER_JOURNEY_HUB: '/her-journey-hub',
  FAQ: '/faq',
  STORIES: '/stories',
  NOT_FOUND: '*',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]
